import { CompanyKununuCultureDimension } from '@/graphql/generated';

const MIN_NUMBER_OF_REVIEWS = 2;

export const hasCultureInfo = (
  cultureCompass?: CompanyKununuCultureDimension | null,
  totalCultureReviews?: number | null
): boolean => {
  return !!cultureCompass && !!totalCultureReviews && totalCultureReviews >= MIN_NUMBER_OF_REVIEWS;
};
